import { FC } from 'react';
import { A11y, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CardImage } from '../';
import { SwiperContainer } from './style';

interface PropertyListingImageCarouselProps {
  imgs: string[];
}

const PropertyListingImageCarousel: FC<PropertyListingImageCarouselProps> = ({ imgs }) => {
  return (
    <SwiperContainer>
      <Swiper
        modules={[Pagination, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
      >
        {imgs.map((image, index) => {
          return (
            <SwiperSlide key={index} data-testid={`property-listing-swiper-slide-${index}`}>
              <CardImage image={image} alt_text={`Property Listing Image ${index}`} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </SwiperContainer>
  );
};

export default PropertyListingImageCarousel;
